import { render, staticRenderFns } from "./takingsOverviewPage.vue?vue&type=template&id=1b4c41be&"
import script from "./takingsOverviewPage.vue?vue&type=script&lang=ts&"
export * from "./takingsOverviewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports